(function() {
    angular
        .module("app")
        .controller("WzCreateModalController", WzCreateModalController)

    WzCreateModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "wzService",
        "success",
        "failure"
    ]

    function WzCreateModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        wzService,
        success,
        failure
    ){
        "use strict"

        $scope.wzConfig = {
            type:           "QWS",
            title:          undefined,
            timezone:       undefined,
            direction:      undefined,
            vehicle_impact: undefined,
            road_name:      undefined
        }

        gtag("event", "create_workzone", { action: "begin" })

        $scope.create = () => {

            $scope.submitted = true

            if ($scope.createWz.$valid) {

                const _success = (data) => {

                    gtag("event", "create_workzone", { action: "complete", wz_id: data.id })

                    wzService.listAll($rootScope.selectedCustomerID).then((wzs) => {
                        $rootScope.wzs = wzs
                    })

                    success(data)

                }

                $uibModalInstance.close(wzService.createWZ($rootScope.selectedCustomerID, $scope.wzConfig, _success, failure))

            }
        }

        $scope.cancel = function() {
            gtag("event", "create_workzone", { action: "cancel" })
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
